import React from 'react'
import TextHeader, { TextSubHeader } from '@/components/UI/TextHeader'
import useContentStack from '@/hooks/useContentStack'
import { CONTENT_STACK_TYPES } from '@/store/Constants'
import { FinishSetupActionList } from '@/components/UI/ECP'
import classes from './FinishSetupPage.module.scss'
import { IconCheckmarkCircle } from '@veneer/core/dist/scripts/icons'

const FinishSetupEcpPage = () => {
  const { pageData } = useContentStack({
    content_type: CONTENT_STACK_TYPES.finish_setup_ecp
  })

  if (!pageData) return <></>

  return (
    <div
      data-testid="finish-setup-page-for-ecp"
      className={classes.finishSetupEcp}
    >
      <div>
        <TextHeader>
          <div className={classes.headerContainer}>
            <span>{pageData.header}</span>
            <IconCheckmarkCircle
              filled
              size={40}
              className={classes.iconCheckmark}
              color="hunterGreen7"
            />
          </div>
        </TextHeader>
        <TextSubHeader>{pageData.subheader}</TextSubHeader>
      </div>
      <FinishSetupActionList
        actionListCopy={pageData.action_list}
        buttonsCopy={pageData.buttons}
      />
    </div>
  )
}

export default FinishSetupEcpPage
